var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state.embedDemo === true)?_c('app-embed',{staticClass:"app"}):(_vm.state.room == null)?_c('app-welcome',{staticClass:"app"}):_c('app-main')}
var staticRenderFns = []

export { render, staticRenderFns }